import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import designService from '../services/design.service';

let checkDesign = (to, from, next) => {
  if (!designService.isValid()) {
    next({ name: 'home' });
  } else {
    next();
  }
};

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/select-block',
    name: 'select-block',
    component: () => import(/* webpackChunkName: "select-block" */ '../views/SelectBlock.vue'),
    beforeEnter: checkDesign,
  },
  {
    path: '/view-block/:blockIdx?',
    name: 'view-block',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "view-design" */ '../views/ViewBlock.vue'),
    props: (route) => ({ blockIdx: route.params.blockIdx || 0 }),
    beforeEnter: checkDesign,
  },
  {
    path: '/view-submesh/:id',
    name: 'view-submesh',
    component: () => import(/* webpackChunkName: "view-submesh" */ '../views/ViewSubmesh.vue'),
    beforeEnter: checkDesign,
  }
]

const router = new VueRouter({
  routes
})

export default router
